var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfil = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#B2B2B2",
  fillRule: "evenodd",
  stroke: "#B2B2B2",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.04 2.513a4.265 4.265 0 0 0-4.186 5.09 4.258 4.258 0 0 0 3.334 3.334 4.265 4.265 0 0 0 5.009-5.01 4.258 4.258 0 0 0-3.335-3.334 4.29 4.29 0 0 0-.823-.08m-.028 8.992c-.305 0-.611-.03-.917-.089a4.754 4.754 0 0 1-3.72-3.72 4.756 4.756 0 0 1 5.582-5.582 4.75 4.75 0 0 1 3.72 3.72 4.752 4.752 0 0 1-4.665 5.67M12.025 13.03c-2.431 0-4.73.62-6.474 1.747-1.856 1.2-2.92 2.889-2.92 4.634v1.085c0 .574.467 1.041 1.04 1.041h16.707c.574 0 1.042-.467 1.042-1.041V19.41c0-1.745-1.065-3.434-2.921-4.634-1.744-1.128-4.043-1.748-6.474-1.748m8.353 8.996H3.672c-.844 0-1.53-.686-1.53-1.53v-1.084c0-1.913 1.146-3.752 3.144-5.044 1.822-1.177 4.215-1.826 6.739-1.826s4.917.649 6.739 1.826c1.998 1.292 3.143 3.13 3.143 5.044v1.085a1.53 1.53 0 0 1-1.529 1.529"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profil.fbc153f4a8f7d3381f7c92c26b1d79c4.svg";